import { render, staticRenderFns } from "./supplierRFQ.vue?vue&type=template&id=a1c9838a&scoped=true&"
import script from "./supplierRFQ.vue?vue&type=script&lang=js&"
export * from "./supplierRFQ.vue?vue&type=script&lang=js&"
import style0 from "./supplierRFQ.vue?vue&type=style&index=0&id=a1c9838a&lang=less&scoped=true&"
import style1 from "./supplierRFQ.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1c9838a",
  null
  
)

component.options.__file = "supplierRFQ.vue"
export default component.exports